import { darkColors, lightColors } from '@tryhackme/thm-ui-components';
import { css } from 'styled-components';

export const CommonBadgeStyles = css`
  .badge {
    display: inline-block;
    padding: 0.7rem 1.2rem;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 10rem;
    margin: 0 0.6rem;
    font-size: 1.4rem !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }
`;

export const DarkBackgroundSummaryBadgeStyles = css`
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    .badge {
      padding: 0.2rem 1rem;
      font-weight: 400;
    }
  }

  .badge-card-info {
    text-align: left;
    margin-left: 21px;
  }

  .badge-soft-dark {
    color: #919398;
    background-color: rgba(99, 99, 99, 0.18);
  }

  .badge-soft-primary {
    color: ${darkColors.info.main};
    background-color: ${darkColors.info.light};
  }

  .badge-soft-info {
    color: #2ee7b6;
    background-color: rgba(46, 231, 182, 0.18);
  }

  .badge-soft-success {
    color: ${lightColors.success.main};
    background-color: ${darkColors.success.lightest};
  }

  .badge-soft-danger {
    color: ${darkColors.error.main};
    background-color: ${darkColors.error.light};
  }

  .badge-soft-purple {
    color: ${darkColors.purple.main};
    background-color: ${darkColors.purple.lighter};
  }

  .badge-soft-warning {
    color: ${darkColors.warning.main};
    background-color: ${darkColors.warning.lightest};
  }
`;

export const MainContentBadgeStyles = css`
  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    .badge {
      padding: 0.2rem 1rem;
      font-weight: 400;
    }
  }

  .badge-card-info {
    text-align: left;
    margin-left: 21px;
  }

  .badge-soft-dark {
    color: #919398;
    background-color: rgba(99, 99, 99, 0.18);
  }

  .badge-soft-primary {
    color: ${lightColors.info.main};
    background-color: ${lightColors.info.lightest};
  }

  .badge-soft-info {
    color: #2ee7b6;
    background-color: rgba(46, 231, 182, 0.18);
  }

  .badge-soft-success {
    color: ${lightColors.success.main};
    background-color: ${lightColors.success.lightest};
  }

  .badge-soft-danger {
    color: ${lightColors.error.main};
    background-color: ${lightColors.error.light.replace('0.3', '0.2')};
  }

  .badge-soft-purple {
    color: ${lightColors.purple.main};
    background-color: ${lightColors.purple.lighter};
  }

  .badge-soft-warning {
    color: rgba(189, 88, 0, 1);
    background-color: rgba(255, 141, 0, 0.2);
  }
`;
